// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"PurchasesListContainer_subtitle__VB6Bc","container":"PurchasesListContainer_container__ERk3X"};